import React from 'react';
import IconButton from './IconButton';
import { TrashIcon, PlusIcon } from './icons';

function getQuantityToneClass(quantity) {
  if (!Number.isFinite(quantity) || quantity <= 0) return 'main-page-productQty--red';
  if (quantity <= 5) return 'main-page-productQty--orange';
  if (quantity <= 15) return 'main-page-productQty--yellow';
  return 'main-page-productQty--green';
}

function VariantRow({ variant, onEdit, onDelete }) {
  const parsedQuantity = Number(variant?.quantity);
  const qty = Number.isFinite(parsedQuantity) ? parsedQuantity : 0;
  const quantityClassName = getQuantityToneClass(qty);
  const label = String(variant?.title ?? '').trim() || 'Обычный';

  return (
    <div className="main-page-productVariant" role="listitem">
      <button
        type="button"
        className="main-page-productVariantMain main-page-productVariantMain--button"
        onClick={onEdit}
        aria-label={`Редактировать вариант: ${label}`}
        title="Редактировать вариант"
      >
        <span className="main-page-productVariantTitle">{label}</span>
        <span className="main-page-productVariantMeta">
          <span>{variant?.price} сом</span>
          <span className={`main-page-productQty ${quantityClassName}`}>{qty} шт.</span>
        </span>
      </button>
      <div className="main-page-productVariantActions">
        <IconButton onClick={onDelete} label="Удалить вариант" title="Удалить вариант">
          <TrashIcon />
        </IconButton>
      </div>
    </div>
  );
}

export default function ProductRow({
  product,
  onEdit,
  onDelete,
  onAddVariant,
  onEditVariant,
  onDeleteVariant,
}) {
  const variants = Array.isArray(product?.variants) ? product.variants : [];
  const multi = variants.length > 1;
  const single = variants.length === 1 ? variants[0] : null;

  const parsedQuantity = Number(single?.quantity ?? product?.quantity);
  const quantity = Number.isFinite(parsedQuantity) ? parsedQuantity : 0;
  const quantityClassName = getQuantityToneClass(quantity);
  const price = single?.price ?? product?.price;
  const productName = product?.name ?? 'товар';

  return (
    <div className={`main-page-productItem${multi ? ' main-page-productItem--multi' : ''}`}>
      <div className="main-page-productItemTop">
        <button
          type="button"
          className="main-page-productImageButton"
          onClick={onEdit}
          aria-label={`Редактировать: ${productName}`}
          title="Редактировать"
        >
          <img
            className="main-page-productImage"
            src={product.imageUrl}
            alt=""
            loading="lazy"
          />
        </button>

        <div className="main-page-productMain">
          <button
            type="button"
            className="main-page-productName main-page-productName--button"
            onClick={onEdit}
            title="Редактировать"
          >
            {product.name}
          </button>
          {!multi && (
            <div className="main-page-productMeta">
              <span>{price} сом</span>
              <span className={`main-page-productQty ${quantityClassName}`}>{quantity} шт.</span>
            </div>
          )}
        </div>

        <div className="main-page-productActions">
          <IconButton onClick={onAddVariant} label="Добавить вариант" title="Добавить вариант">
            <PlusIcon />
          </IconButton>

          <IconButton onClick={onDelete} label="Удалить" title="Удалить">
            <TrashIcon />
          </IconButton>
        </div>
      </div>

      {multi ? (
        <div className="main-page-productVariants" role="list">
          {variants.map((variant) => {
            const id = variant?._id ?? variant?.id;
            return (
              <VariantRow
                key={id}
                variant={variant}
                onEdit={() => onEditVariant?.(variant)}
                onDelete={() => onDeleteVariant?.(variant)}
              />
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
